module.exports = __webpack_public_path__ + "img/placeholder.83e82389.svg";